/** BOM types — snake_case mirrors server DTO (materials-style). */

export type BomStatus = 'inactive' | 'active' | 'archived'

export type AssemblyType = 'assembled' | 'kd'
export type IstaLevel = '1A' | '3A'

export type Bom = {
  id: string
  product_id: string | null
  code_hint: string | null
  name: string
  version_label: string
  version_seq: number
  bom_family_id: string
  status: BomStatus
  assembly_type: AssemblyType
  edit_count?: number
  edit_note?: string | null
  edited_by?: string | null
  edited_at?: string | null
  prepared_by: string | null
  checked_by: string | null
  checked_by_2: string | null
  approved_by: string | null
  signed_on: string | null
  notes: string | null
  created_by: string | null
  updated_by: string | null
  version: number
  created_at: string
  updated_at: string
}

export type BomWoodLine = {
  id: string
  bom_id: string
  sort_order: number
  part_name: string
  part_group: string | null
  material_id: string | null
  dims_finished_t: number | null
  dims_finished_w: number | null
  dims_finished_l: number | null
  dims_rough_t: number | null
  dims_rough_w: number | null
  dims_rough_l: number | null
  tenon: string | null
  qty_per: number
  m3_finished?: number | null
  m3_piece?: number | null
  m3_total?: number | null
  has_missing_dims?: boolean
  veneer_spec: string | null
  notes: string | null
  wood_type_raw: string | null
  created_at: string
  updated_at: string
}

export type BomPackagingOption = {
  id: string
  bom_id: string
  assembly_type: AssemblyType
  ista_level: string
  label: string | null
  created_at?: string
  updated_at?: string
}

export type BomHardwareLine = {
  id: string
  bom_id: string
  sort_order: number
  name_raw: string
  spec_raw: string | null
  material_id: string | null
  qty_per: number
  uom_hint: string | null
  color_hint: string | null
  notes: string | null
  created_at: string
  updated_at: string
}

export type BomPackagingLine = {
  id: string
  bom_id: string
  sort_order: number
  name_raw: string
  spec_raw: string | null
  material_id: string | null
  qty_per: number
  uom_hint: string | null
  notes: string | null
  created_at?: string
  updated_at?: string
}

export type WoodSummaryGroup = {
  wood_type: string
  total_m3: number
  part_count: number
  qty_total: number
}

export type WoodSummary = {
  by_type: WoodSummaryGroup[]
  total_m3: number
  total_parts: number
  missing_dims_count: number
  has_missing_dims: boolean
}

export type BomDetail = Bom & {
  woodLines: BomWoodLine[]
  packagingOptions: BomPackagingOption[]
  hardwareLines: BomHardwareLine[]
  packagingLines: BomPackagingLine[]
  mappedVariantIds: string[]
  wood_summary?: WoodSummary
}

export type BomCreateInput = {
  name: string
  assembly_type?: AssemblyType
  version_label?: string
  code_hint?: string | null
  product_id?: string | null
  notes?: string | null
}

export type BomHeaderPatchInput = {
  name?: string
  code_hint?: string | null
  product_id?: string | null
  version_label?: string
  prepared_by?: string | null
  checked_by?: string | null
  checked_by_2?: string | null
  approved_by?: string | null
  signed_on?: string | null
  notes?: string | null
}

export const BOM_STATUS_LABEL: Record<BomStatus, string> = {
  active: 'ACTIVE',
  inactive: 'INACTIVE',
  archived: 'ARCHIVED',
}
